import { invoke } from '@shared/easyfy.decorators';
import SliderHelper from '@clientShared/sliderHelper';
@invoke
export default class KevelBrandedShelfComponent {
  static Instance: KevelBrandedShelfComponent;
  private static readonly PER_PAGE = 2;

  onInit() {
    KevelBrandedShelfComponent.refreshComponent();
  }

  private static getNumberOfSlides = (list: HTMLElement): number => {
    return list.querySelectorAll('.splide__slide').length;
  };

  static refreshComponent = (): void => {
    const selector = '[data-container="branded-shelf-slider"]';
    document.querySelectorAll(selector).forEach((list) => {
      if (!(list instanceof HTMLElement) || list.classList.contains('splide')) return;

      const numberOfSlides = KevelBrandedShelfComponent.getNumberOfSlides(list);
      if (numberOfSlides === 0) {
        list.remove();
        return;
      }

      if (numberOfSlides <= KevelBrandedShelfComponent.PER_PAGE) {
        return;
      }

      list.classList.add('splide');
      const slider = SliderHelper.CreateSlider(list, {
        type: 'loop',
        perPage: KevelBrandedShelfComponent.PER_PAGE,
        arrows: true,
        gap: 10,
        snap: false,
        mediaQuery: 'min',
        breakpoints: {
          1100: {
            perPage: KevelBrandedShelfComponent.PER_PAGE,
          },
          768: {
            perPage: 1,
          },
        },
      });

      SliderHelper.MountSlider(slider);
    });
  };
}
